<template>
  <TableCell
    :tag
    :selectedCells
    v-model:showingPopover="showingPopover"
    v-model:columnSelectionCode="columnSelectionCode"
    v-bind="$attrs"
  >
    {{ tag.value.length > 0 ? '*****' : 'No password configured' }}

    <template #BinSelectionInput>
      <slot name="BinSelectionInput"></slot>
    </template>

    <template #PopoverContentDesktop>
      <h3 style="text-align: center; margin-bottom: 20px;">
        Password
      </h3>
      <div style="display: flex; flex-direction: column; gap: 5px;">
        <div style="display: flex; align-items: center;">
          <label>
            New password
          </label>
          <InputText type="password" autocomplete="off" v-model="newPassword"></InputText>
        </div>
        <div style="display: flex; align-items: center;">
          <label>
            Confirm new password
          </label>
          <InputText type="password" autocomplete="off" v-model="confirmPassword" :invalid="!isPasswordConfirmed" @keypress.enter="ok()"></InputText>
        </div>
      </div>
      <div style="margin-top: 20px; display: flex; gap: 10px;">
        <slot name="BinSelectionInput"></slot>
        <Button :disabled="!isPasswordConfirmed" style="flex-grow: 1; flex-basis: 0; justify-content: center;" @click="ok()">
          Ok
        </Button>
        <Button severity="secondary" style="flex-grow: 1; flex-basis: 0; justify-content: center;" @click="cancel()">
          Cancel
        </Button>
      </div>
    </template>
  </TableCell>
</template>

<script setup>
import { computed, ref, watch } from "vue";
import TableCell from "./TableCell.vue";
import { changeSettings } from "./appUtility";

let props = defineProps([
  "tag",
  "selectedCells",
  "showingPopover",
  "columnSelectionCode"
]);

let showingPopover = defineModel("showingPopover");
let columnSelectionCode = defineModel("columnSelectionCode");

let newPassword = ref("");
let confirmPassword = ref("");
watch(showingPopover, () => {
  newPassword.value = "";
  confirmPassword.value = "";
});

let isPasswordConfirmed = computed(() => {
  return newPassword.value == confirmPassword.value;
});

function ok() {
  if (!isPasswordConfirmed.value) return;

  changeSettings(props.selectedCells, cell => [{
    handle: cell.componentArgs.tag.handle,
    value: newPassword.value
  }]);
}

function cancel() {
  showingPopover.value = false;
}
</script>

<style scoped>
label {
  display: inline-block;
  width: 195px;
  text-align: right;
  padding: 10px;
}
input {
  text-align: center;
}
</style>